module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "message"
  }, [(_vm.sentiment) ? _c('div', {
    staticClass: "sentiment pull-right"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Neutral"
    }
  }, [(_vm.sentiment === 'neutral') ? _c('span', [_c('i', {
    staticClass: "fa fa-minus neutral"
  })]) : _vm._e()]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Negative"
    }
  }, [(_vm.sentiment === 'negative') ? _c('span', [_c('i', {
    staticClass: "fa fa-arrow-down negative"
  })]) : _vm._e()]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Positive"
    }
  }, [(_vm.sentiment === 'positive') ? _c('span', [_c('i', {
    staticClass: "fa fa-arrow-up positive"
  })]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "avatar pull-left"
  }, [(_vm.getAvatar) ? _c('img', {
    staticClass: "img-circle",
    class: {
      clickable: _vm.getAvatar !== _vm.defaultAvatar
    },
    attrs: {
      "src": _vm.getAvatar
    },
    on: {
      "error": function($event) {
        _vm.avatarError = true
      },
      "click": function($event) {
        _vm.getAvatar !== _vm.defaultAvatar && _vm.showGallery([
          [_vm.getAvatar], 0
        ])
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.getAvatar) ? _c('div', {
    staticClass: "img-circle",
    style: ({
      'background-color': _vm.channelMeta[_vm.channel].color
    })
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.channelMeta[_vm.channel].icon
  })]) : _vm._e()]), _vm._v(" "), (_vm.displayName.length > 0) ? _c('div', {
    staticClass: "originator"
  }, [_c('span', {
    staticClass: "profile-display",
    on: {
      "click": _vm.handleOpenProfile
    }
  }, [_vm._v(_vm._s(_vm.displayName))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.originator))])])]) : _vm._e(), _vm._v(" "), (_vm.displayName.length === 0) ? _c('div', {
    staticClass: "originator"
  }, [_c('span', {
    staticClass: "profile-display",
    on: {
      "click": _vm.handleOpenProfile
    }
  }, [_vm._v(_vm._s(_vm.originator))])]) : _vm._e(), _vm._v(" "), (_vm.isOnAir) ? _c('span', {
    staticClass: "sent-by pull-right"
  }, [_vm._v("\n        " + _vm._s(_vm.sentOnAirBy) + "\n        "), _c('i', {
    staticClass: "fa fa-user"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "time",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeDatetimePostFormat($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.displayDatetime) + "\n        via " + _vm._s(_vm.channelMeta[_vm.channel].title) + "\n        "), _c('span', {
    staticClass: "originator-type img-circle",
    style: ({
      'background-color': _vm.channelMeta[_vm.channel].color
    })
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.channelMeta[_vm.channel].icon
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "message-content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedMessage)
    }
  }), _vm._v(" "), (_vm.message.length > _vm.messageLength && !_vm.isExpanded) ? _c('div', {
    staticClass: "read-more"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.isExpanded = true
      }
    }
  }, [_vm._v("\n          Show more\n          "), _c('i', {
    staticClass: "fa fa-angle-down"
  })])]) : _vm._e(), _vm._v(" "), (_vm.message.length > _vm.messageLength && _vm.isExpanded) ? _c('div', {
    staticClass: "read-more"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.isExpanded = false
      }
    }
  }, [_vm._v("\n          Show less\n          "), _c('i', {
    staticClass: "fa fa-angle-up"
  })])]) : _vm._e(), _vm._v(" "), (_vm.audio.length) ? _c('div', {
    staticClass: "audio-container"
  }, _vm._l((_vm.audio), function(aud, index) {
    return _c('audio', {
      key: aud,
      ref: ("audio" + index),
      refInFor: true,
      attrs: {
        "src": aud,
        "controls": "controls",
        "preload": _vm.mediaPreload
      },
      on: {
        "play": function($event) {
          return _vm.handleMediaStarted()
        },
        "ended": function($event) {
          return _vm.handleMediaEnded()
        },
        "pause": function($event) {
          return _vm.handleMediaEnded()
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (_vm.video.length) ? _c('div', {
    staticClass: "video-container"
  }, _vm._l((_vm.video), function(vid, index) {
    return _c('video', {
      key: vid,
      ref: ("video" + index),
      refInFor: true,
      staticClass: "video-item",
      attrs: {
        "src": vid,
        "controls": "controls",
        "preload": _vm.mediaPreload
      },
      on: {
        "play": function($event) {
          return _vm.handleMediaStarted()
        },
        "ended": function($event) {
          return _vm.handleMediaEnded()
        },
        "pause": function($event) {
          return _vm.handleMediaEnded()
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (_vm.images.length) ? _c('div', {
    staticClass: "images-container"
  }, [_c('image-grid', {
    attrs: {
      "box-width": '370',
      "box-height": '370px',
      "images": _vm.images
    },
    on: {
      "imageSelected": _vm.showGallery
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.document.length) ? _c('div', {
    staticClass: "message-container"
  }, _vm._l((_vm.document), function(doc, index) {
    return _c('a', {
      key: doc,
      ref: ("document" + index),
      refInFor: true,
      attrs: {
        "href": doc
      }
    }, [_vm._v(_vm._s(("document_" + (doc.slice(-20)))))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.text.length) ? _c('div', {
    staticClass: "message-container"
  }, _vm._l((_vm.text), function(txt, index) {
    return _c('a', {
      key: txt,
      ref: ("text" + index),
      refInFor: true,
      attrs: {
        "href": txt
      }
    }, [_vm._v(_vm._s(_vm.getDocumentName(txt)))])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "message-tools"
  }, [(_vm.showTools && !_vm.isOnAir) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Send to on air",
      "placement": "bottom"
    }
  }, [_c('a', {
    staticClass: "onair",
    on: {
      "click": function($event) {
        return _vm.setInput('onair')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showTools && _vm.threadId && _vm.threadId !== '' && _vm.inCount > 0) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Conversation",
      "placement": "bottom"
    }
  }, [_c('a', {
    staticClass: "thread",
    on: {
      "click": _vm.showThread
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showTools && _vm.threadId && _vm.threadId !== '' && _vm.inCount > 0) ? _c('div', {
    staticClass: "thread-counts"
  }, [_c('span', {
    staticClass: "in"
  }, [_vm._v(_vm._s(_vm.inCount))]), _vm._v(" "), (_vm.outCount > 0) ? _c('span', [_vm._v("\n        /\n        "), _c('span', {
    staticClass: "out"
  }, [_vm._v(_vm._s(_vm.outCount))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showTools) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Comment",
      "placement": "bottom"
    }
  }, [_c('a', {
    staticClass: "comment",
    on: {
      "click": function($event) {
        return _vm.setInput('comment')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showTools && _vm.channelMeta[_vm.channel].title === 'Facebook Comment') ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Like",
      "placement": "bottom"
    }
  }, [_c('a', {
    staticClass: "like",
    on: {
      "click": function($event) {
        return _vm.likePost(_vm.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showTools && _vm.channelMeta[_vm.channel].title === 'Facebook Post') ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Export comments",
      "placement": "bottom"
    }
  }, [_c('a', {
    staticClass: "export-comments",
    on: {
      "click": function($event) {
        return _vm.exportFacebookPostComments(_vm.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showTools && _vm.hasTranscript) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Transcript",
      "placement": "bottom"
    }
  }, [_c('a', {
    staticClass: "show-audio-transcript",
    on: {
      "click": function($event) {
        _vm.showAudioTranscript = !_vm.showAudioTranscript
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-audio-o"
  })])]) : _vm._e(), _vm._v(" "), (_vm.commentsAndRepliesCount && !_vm.showCommentsAndReplies) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.showCommentsAndReplies = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-toggle-down"
  }), _vm._v(" "), _c('span', {
    staticClass: "comment-count"
  }, [_vm._v(_vm._s(_vm.commentsAndRepliesCount))])]) : _vm._e(), _vm._v(" "), (_vm.commentsAndRepliesCount && _vm.showCommentsAndReplies) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.showCommentsAndReplies = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-toggle-up"
  }), _vm._v(" "), _c('span', {
    staticClass: "comment-count"
  }, [_vm._v(_vm._s(_vm.commentsAndRepliesCount))])]) : _vm._e(), _vm._v(" "), (_vm.isOnAir) ? _c('span', [_c('el-tooltip', {
    staticClass: "pull-right",
    attrs: {
      "effect": "dark",
      "content": "Remove from on air",
      "placement": "bottom"
    }
  }, [_c('a', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.$emit('removeOnAir')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.parentInteraction !== null && _vm.parentInteraction.ore !== null) ? _c('parent-interaction', {
    attrs: {
      "collapsible": _vm.autoCollapseParentInteraction,
      "interaction": _vm.parentInteraction
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showInput == 'onair') ? _c('div', {
    staticClass: "onair-input"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Send on air to"
    },
    model: {
      value: (_vm.computedOnAirUser),
      callback: function($$v) {
        _vm.computedOnAirUser = $$v
      },
      expression: "computedOnAirUser"
    }
  }, _vm._l((_vm.onAirUsers), function(user) {
    return _c('el-option', {
      key: user.id,
      attrs: {
        "label": user.display_name,
        "value": user.id
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "input-controls"
  }, [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.sendOnAir
    }
  }, [_vm._v("Send")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showInput == 'comment') ? _c('div', {
    staticClass: "comment-input"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "Leave a comment..."
    },
    model: {
      value: (_vm.commentMessage),
      callback: function($$v) {
        _vm.commentMessage = $$v
      },
      expression: "commentMessage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-controls"
  }, [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.sendComment
    },
    model: {
      value: (_vm.commentMessage),
      callback: function($$v) {
        _vm.commentMessage = $$v
      },
      expression: "commentMessage"
    }
  }, [_vm._v("Comment")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showCommentsAndReplies && _vm.commentsAndRepliesCount) ? _c('div', {
    staticClass: "interact"
  }, _vm._l((_vm.commentsAndReplies), function(commentOrReply) {
    return _c('div', {
      key: commentOrReply.batch_uuid
    }, [(commentOrReply.type === 'comment') ? _c('div', {
      staticClass: "comments"
    }, [_c('message-comment', {
      attrs: {
        "datetime": commentOrReply.date_created,
        "message": commentOrReply.value
      }
    })], 1) : _vm._e(), _vm._v(" "), (commentOrReply.type === 'reply') ? _c('div', {
      staticClass: "replies"
    }, [_c('message-reply', {
      attrs: {
        "fullName": commentOrReply.full_name,
        "datetime": commentOrReply.date_created,
        "message": commentOrReply.value
      }
    })], 1) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.showAudioTranscript) ? _c('div', {
    staticClass: "transcript"
  }, [_c('audio-transcript', {
    attrs: {
      "transcript": _vm.audioTranscript
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-746576b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/interaction/Message.vue
// module id = 3340
// module chunks = 3